import { cursoDeleteApi, cursoPutApi } from "#api/Api_cursos"
import { MasterDialog } from "#common/Dialog/Dialog"
import InputText from "#common/input/InputText"
import { useApiSend } from "#hooks/useApiSend"
import { STATUS_COURSE } from "#training/constants"
import { UseTarjetaContext } from "#training/contexts/contextsTarjeta"
import { UseReload } from "#training/redux/actions"
import {
	courseCollaboratorIdDelete,
	courseCollaboratorIdPut,
} from "#training/services/Api"
import { Stack, Typography } from "@mui/material"
import { ESTADO_CURSOS } from "Components/Capacitaciones/constants_capacitaciones"
import { useMemo, useState } from "react"
import { toast } from "react-toastify"

const TarjetaDialog = () => {
	const {
		openDialog: open,
		setOpenDialog: setOpen,
		curso: { id },
		newStatus,
	} = UseTarjetaContext()
	const reloadNow = UseReload()
	const [message, setMessage] = useState("")
	const handleClose = () => {
		setOpen(false)
	}
	const success = () => {
		handleClose()
		reloadNow()
	}
	const { fetch: fetchPut } = useApiSend(courseCollaboratorIdPut, { success })
	const { fetch: fetchDelete } = useApiSend(courseCollaboratorIdDelete, { success })

	const warning = {
		[STATUS_COURSE.APROBADO]: "Aprobar",
		[STATUS_COURSE.RECHAZADO]: "Rechazar",
		[STATUS_COURSE.CANCELADO]: "Cancelar",
		Eliminar: "Eliminar",
	}

	async function aceptar() {
		if (newStatus === ESTADO_CURSOS.RECHAZADO && message?.trim() === "") {
			toast.error("Debes escribir un motivo para rechazar el curso")
			return null
		}

		if (newStatus !== "eliminar")
			fetchPut(
				id,
				{
					status: newStatus,
					mensaje: message,
				},
				{ status: true }
			)
		else {
			fetchDelete(id)
		}
	}

	const content = useMemo(() => {
		if (newStatus === ESTADO_CURSOS.RECHAZADO)
			return <InputText label="Motivo del rechazo" setValue={setMessage} />
		else return null
	}, [newStatus])

	return (
		<MasterDialog
			title={`Confirmación`}
			open={open}
			setOpen={setOpen}
			closeDialog={handleClose}
			buttons={[
				{ label: "Cancelar", onClick: handleClose },
				{ label: "Aceptar", onClick: aceptar },
			]}
		>
			<Stack spacing={2}>
				<Typography textAlign={"center"}>
					¿Estas seguro de {warning[newStatus] || "Eliminar"} este curso?
				</Typography>
				{content}
			</Stack>
		</MasterDialog>
	)
}
export default TarjetaDialog
